import type { OfferBundleDetails } from '../types';

function shouldShowLoginButtons(isAuthenticated: boolean, data: OfferBundleDetails): boolean {
  const shouldShowForAuth = !isAuthenticated;

  const isOfferDisabled = data.bundleStatus === 'CLAIMED' || data.bundleStatus === 'EXPIRED' || data.bundleStatus === 'CANCELLED';

  return shouldShowForAuth && !isOfferDisabled;
}

function getStepCode(isBundleFirstStepOrAction: boolean | string | null, bundleCode: string | undefined, offerCode?: string | undefined): string {
  const isBundleFirstStep = typeof isBundleFirstStepOrAction === 'boolean' ? isBundleFirstStepOrAction : isBundleFirstStepOrAction === 'DEPOSIT';
  return isBundleFirstStep ? (bundleCode ?? '') : (offerCode ?? bundleCode ?? '');
}

function getOfferContinueButtonTrackingAttributes(currentStep: string | undefined, stepCode: string | undefined, currentAction: string): Record<string, string> {
  return {
    'data-track-name': 'Continue',
    'data-track-step': currentStep ?? '',
    'data-track-code': stepCode ?? '',
    'data-track-action': currentAction,
  };
}

export { getOfferContinueButtonTrackingAttributes, getStepCode, shouldShowLoginButtons };
